import { themeGet } from "styled-system";
import { transparentize } from "polished";

export default (color, transparency = 0, direction = "to top") => p => {
  const c = themeGet(`colors.${color}`)(p) || color;
  const from = transparentize(transparency, c);
  const to = transparentize(1, c);
  return `linear-gradient(${[direction, from, to].join(", ")})`;
};
